import { Component, ElementRef, ViewChild, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { GoogleMap, GoogleMapsModule } from '@angular/google-maps';
import { MarkerClusterer } from '@googlemaps/markerclusterer';
import { CommonModule } from '@angular/common';
import { NgZone } from '@angular/core';
import { ModalGoogleMapComponent } from '../../../modals/out-category/parking-center/modal-google-map/modal-google-map.component';
import { ParkingLocation } from '../../../../../core/models/parking-center/parking-center.model';
import { CookieService } from 'ngx-cookie-service';
import { LanguageService } from '../../../../../core/services/language.service';
import { ToastNotifService } from '../../../../../core/services/toastNotif.service';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { LoaderGoogleMapComponent } from "../../../../style/loader-google-map/loader-google-map.component";
import { ToastWarnComponent } from "../../../../../tools/template/toast/toast-warn/toast-warn.component";
import { ToastFailedComponent } from "../../../../../tools/template/toast/toast-failed/toast-failed.component";
import { ToastSuccessComponent } from "../../../../../tools/template/toast/toast-success/toast-success.component";
import { ToastCustomService } from '../../../../../tools/services/toast/toast-custom/toastCustom.service';
import { HomeTopUpModel } from '../../../../../core/models/user.model';
import { ApiTopUpService } from '../../../../../core/services/api/Topup/api-topup';
import { ApiParkingCenterService } from '../../../../../core/services/api/Parking-center/api-parking-center';
import { SiteAmenitiesComponent } from '../../../../../shared/components/site-amenities/site-amenities.component';

@Component({
  selector: 'app-parking-center',
  imports: [
    GoogleMapsModule,
    ModalGoogleMapComponent,
    CommonModule,
    FormsModule,
    LoaderGoogleMapComponent,
    SiteAmenitiesComponent
  ],
  templateUrl: './parking-center.component.html',
  styleUrl: './parking-center.component.css'
})
export class ParkingCenterComponent implements OnInit, AfterViewInit, OnDestroy {

  // -- Map ---
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  @ViewChild('searchBox', { static: false }) searchBox!: ElementRef;

  currentLocation!: google.maps.LatLngLiteral;
  markers: google.maps.Marker[] = [];
  zoom = 12;
  isFirstUpdate = true;
  defaultLocation: google.maps.LatLngLiteral = {
    lat: 13.7563,
    lng: 100.5018,
  };
  center: google.maps.LatLngLiteral = {
    lat: 13.7563,
    lng: 100.5018,
  };


  // Cluster
  clusterer!: MarkerClusterer;// Marker clusterer instance
  watchId: number | undefined;// Watcher id for geolocation
  currentLocationMarker?: google.maps.Marker;// Marker for current location
  customMarkers: CustomMarker[] = [];

  // Data
  markerPositions: ParkingLocation[] = [
    // { site_id: 1, name: 'Parking PSS 1', lat: 13.7563, lng: 100.5018, available: 12 },
    // { site_id: 2, name: 'Parking PSS 2', lat: 13.7570, lng: 100.5020, available: 0 },
    // { site_id: 3, name: 'Parking PSS 3', lat: 13.9580, lng: 100.5030, available: 3 },
    // { site_id: 4, name: 'Parking PSS 4', lat: 13.609352097265415, lng: 100.62586513790883, available: 20 },
    // { site_id: 5, name: 'Parking PSS 5', lat: 13.607352097265415, lng: 100.62386513790883, available: 1 },
  ];
  phone: string = '012-345-6789';
  email: string = 'L4mYK@example.com';

  // Option UI map
  mapOptions: google.maps.MapOptions = {
    disableDefaultUI: true,
    zoomControl: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,

    // 👇 เพิ่มส่วนนี้เข้าไปครับ เพื่อปิดสถานที่ต่างๆ (POI)
    styles: [
      // 1. พื้นหลังรวมๆ ให้เป็นสีครีมอ่อนๆ ถนอมสายตา
      {
        featureType: "landscape",
        stylers: [{ color: "#f5f5f5" }]
      },
      // 2. น้ำสีฟ้าพาสเทลตุ่นๆ (ไม่แย่งซีน)
      {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#b1e2f4" }]
      },
      {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#b1e2f4" }]
      },
      // 3. ปิดไอคอนรกๆ บนแผนที่ เพื่อให้หมุด EV เราเด่นสุด
      {
        featureType: "poi",
        elementType: "labels.icon",
        stylers: [{ visibility: "off" }]
      },
      // 4. สถานที่ (POI) ให้เป็นสีเทาจางๆ
      {
        featureType: "poi",
        elementType: "geometry",
        stylers: [{ color: "#eeeeee" }]
      },
      {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cc9f68" }]
      },
      // 5. สวนสาธารณะ ให้เขียวจางมากๆ
      {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ color: "#e5e5e5" }]
      },
      {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{ color: "#9e9e9e" }]
      },
      // 6. ถนนสีขาว ตัดขอบเทาอ่อนๆ อ่านทางง่าย
      {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#ffffff" }]
      },
      {
        featureType: "road.arterial",
        elementType: "labels.text.fill",
        stylers: [{ color: "#757575" }]
      },
      {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#dadada" }]
      },
      {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cc9f68" }]
      },
      {
        featureType: "road.local",
        elementType: "labels.text.fill",
        stylers: [{ color: "#cc9f68" }]
      },
      // 7. เส้นขอบเขตต่างๆ
      {
        featureType: "transit.line",
        elementType: "geometry",
        stylers: [{ color: "#e5e5e5" }]
      },
      {
        featureType: "transit.station",
        elementType: "geometry",
        stylers: [{ color: "#eeeeee" }]
      }
    ]
  };

  // Search
  searchLocationMarker?: google.maps.Marker;
  infoWindow = new google.maps.InfoWindow();
  searchLocation?: google.maps.LatLngLiteral;
  autocompleteInitialized = false;
  @ViewChild('searchInput', { static: false })
  searchInputRef!: ElementRef<HTMLInputElement>;
  autocomplete!: google.maps.places.Autocomplete;
  filteredParking: ParkingLocation[] | null = [];
  textSearch = '';

  // Modal
  showModal = false;
  showLegendModal = false;

  // Other Component
  selectSiteId = 0;
  selectName: string = '';
  selectPosition: google.maps.LatLngLiteral = { lat: 0, lng: 0 };
  selectedAvailable = 0;
  selectedDistance = 0;
  selectedPrice = 0;
  selectPublicRef: string | null = null;

  // Style
  activeIndex = -1;
  activeColor = '';
  buttonWidth = 80; // match w-[80px] ใน Tailwind
  nearbyFormLocation = 1;
  filterForm = 0;
  menuOpen = false;
  isCustomForm = false; // ใช้สำหรับแสดง/ซ่อนฟอร์มค้นหาตามระยะทางที่กำหนด
  isCustomRadius = false
  isLoading = true;
  isSearchOpen = false;

  // Token
  token = '';

  // Language
  currentLanguage: "TH" | "EN" = 'TH';

  // Length find
  selectedRadius = 100; // เริ่มต้นที่ 500 เมตร
  filteredSpots: ParkingLocation[] = [];

  // HOME TOP UP
  topUpData: HomeTopUpModel = {
    vehicleCount: 0,
    evCount: 0,
    amount: 0,
    activateCard: 0,
    notify: 0,
  };
  uid: string = '';

  // Alert
  isSuccess: boolean = false;
  textSuccess: string = '';
  detailSuccess: string = '';
  isWarning: boolean = false
  textWarn: string = ''
  detailWarn: string = ''
  isError: boolean = false
  textError: string = ''
  detailError: string = ''

  targetLat: number | null = null;
  targetLng: number | null = null;

  constructor(
    private ngZone: NgZone,
    private apiTopUpService: ApiTopUpService,
    private apiParkingCenterService: ApiParkingCenterService,
    private cookieService: CookieService,
    private langService: LanguageService,
    private toast: ToastNotifService,
    private toastCustomService: ToastCustomService,
    private route: ActivatedRoute
  ) {
    this.langService.currentLang$.subscribe(lang => {
      this.currentLanguage = lang;
      console.log('Current language:', this.currentLanguage);
    });
  }

  ngOnInit(): void {
    this.uid =
      this.cookieService.get('line_uid') || localStorage.getItem('line_uid') || '';
    // JWT is HttpOnly cookie — token_user no longer used
    this.token = '';

    this.route.queryParams.subscribe(params => {
      if (params['lat'] && params['lng']) {
        this.targetLat = parseFloat(params['lat']);
        this.targetLng = parseFloat(params['lng']);
        this.center = {
          lat: this.targetLat,
          lng: this.targetLng
        };
        this.zoom = 16;
      }
    });

    console.log("Token : ", this.token, "UID : ", this.uid);
    setTimeout(() => {
      this.getHomeTopUp();
      this.getParkingLocations();
      this.startWatchingPosition();
    }, 100);



    //console.log("Token : " , this.token);
  }

  ngAfterViewInit(): void {
    this.initMarkersAndCluster();
    //this.initAutocomplete();
  }

  ngOnDestroy(): void {
    if (this.watchId !== undefined) {
      navigator.geolocation.clearWatch(this.watchId);
    }
  }

  /*#################################################### Function ################################################*/

  /**
   * Checks if passed coordinates match any parking location and centers map on it, opening its details modal.
   */
  checkAndCenterOnPassedCoordinates() {
    if (this.targetLat !== null && this.targetLng !== null) {
      console.log('Checking passed coordinates:', this.targetLat, this.targetLng);
      // Look for a matching site in markerPositions within a tolerance of 0.005 degrees
      const matchedSite = this.markerPositions.find(pos => {
        const dLat = Math.abs(pos.lat - this.targetLat!);
        const dLng = Math.abs(pos.lng - this.targetLng!);
        return dLat < 0.005 && dLng < 0.005;
      });

      if (matchedSite) {
        console.log('Matched site found:', matchedSite);
        setTimeout(() => {
          if (this.map && this.map.googleMap) {
            const position = { lat: matchedSite.lat, lng: matchedSite.lng };
            this.map.googleMap.setCenter(position);
            this.map.googleMap.setZoom(16);
            const distance = this.calculateDistance(this.currentLocation || this.defaultLocation, position);
            const price = 100;
            this.openModal(matchedSite.siteId, matchedSite.name, position, matchedSite.available, distance, price);
          }
        }, 1000);
      } else {
        console.log('No matching site found in DB, centering map directly.');
        setTimeout(() => {
          if (this.map && this.map.googleMap) {
            const position = { lat: this.targetLat!, lng: this.targetLng! };
            this.map.googleMap.setCenter(position);
            this.map.googleMap.setZoom(16);
            this.showWarning(
              this.currentLanguage === 'TH'
                ? 'ไม่พบสถานที่จอดรถที่เป็นสมาชิกของระบบในพิกัดนี้'
                : 'No system partner parking site found at these coordinates.'
            );
          }
        }, 1000);
      }
    }
  }
  /* --- Style ---*/
  // Alert
  showWarning(text: string, detail: string = '') {
    // this.toast.warning(text);
    this.toastCustomService.showWarning('', text)
  }
  showError(text: string, detail: string = '') {
    // this.toast.error(text);
    this.toastCustomService.showError('', text)
  }
  showSuccess(text: string, detail: string = '') {
    // this.toast.success(text);
    this.toastCustomService.showSuccess('', text)
  }

  toggleLegend() {
    this.showLegendModal = !this.showLegendModal;
    // this.nearbyFormLocation = -1
    console.log(this.showLegendModal);
  }
  toggleCustomForm() {
    this.isCustomForm = !this.isCustomForm;
    this.nearbyFormLocation = 1
    this.selectedRadius = 100
    this.filterForm = 0

    this.runFunctionFilterActive()
    console.log("isCustomForm :", this.isCustomForm);
  }
  selectColor(index: number, color: string) {
    if (this.activeIndex === index) {
      this.activeIndex = -1;
      this.activeColor = '';
    } else {
      this.activeIndex = index;
      this.activeColor = color;
    }

    // เรียก filter ตามสี
    this.filterParkingByColor(this.activeIndex);
  }
  clickCenter() {
    // this.resetData();
    this.centerMapOnButtonLocation();
  }
  clickNearbyForm(event: number) {

    // When click current form
    // if (event === this.nearbyFormLocation) {
    //   this.nearbyFormLocation = 1;
    // }
    // else {
    //   this.nearbyFormLocation = event
    // }
    this.nearbyFormLocation = event
    this.runFunctionFilterActive()
    this.setMarkerMap();
  }
  clickFormCustom() {
    console.log("isCustomRadius :", this.isCustomRadius);
    this.runFunctionFilterActive()
    this.setMarkerMap();
  }
  clickFilterForm(selectFilter: number) {
    if (selectFilter === this.filterForm) {
      this.resetData();
      this.filterForm = 0
      return
    }
    // Ev
    if (selectFilter === 1) {
      // ตั้งค่าเริ่มต้นเป็น ทั้งหมด
      if (this.nearbyFormLocation === -1) {
        this.nearbyFormLocation = 1;
      }
      this.filterForm = selectFilter
    }

    this.runFunctionFilterActive()
    //  🔴 Clear existing custom markers
    // this.removeMarkers();
    this.setMarkerMap();

    console.log("Select filter : ", this.filterForm);
  }


  toggleMenu() {
    this.menuOpen = !this.menuOpen;
  }





  /* --------------------------------- ฟังก์ชัน ----------------------------*/



  // ------------------ Search ------------------
  clearSearchBox() {
    if (this.searchInputRef && this.searchInputRef.nativeElement) {
      this.searchInputRef.nativeElement.value = '';
    } else {
      console.warn('searchBox is undefined');
    }
    this.resetData();
  }

  activateAutocomplete() {
    const input = this.searchInputRef?.nativeElement as HTMLInputElement;

    console.log('Function searchInput : ', this.autocompleteInitialized, input.value);

    if (this.autocompleteInitialized) return;

    // ✅ เช็คว่ามี input จริงไหม
    if (!input) {
      console.error('❌ searchInputRef not found.');
      return;
    }

    // ✅ เช็คค่าว่าง ไม่ให้ส่ง request ไป
    if (!input.value || input.value.trim() === '') {
      console.warn('⚠️ Input is empty, skip autocomplete init.');
      return;
    }

    this.autocompleteInitialized = true;

    this.autocomplete = new google.maps.places.Autocomplete(input, {
      fields: ['geometry', 'name'],
      componentRestrictions: { country: 'TH' },
      types: ['establishment'],
    });

    this.autocomplete.addListener('place_changed', () => {
      const place = this.autocomplete.getPlace();
      console.log('Place changed:', place);
      if (place?.geometry?.location) {
        this.map.googleMap!.setCenter(place.geometry.location);
        this.map.googleMap!.setZoom(16);

        //this.addSearchLocationMarker(place.geometry.location.toJSON());
      } else {
        console.warn('⚠️ ไม่มีผลลัพธ์จากการค้นหา');
      }
    });
  }
  isSearchEvChargerOnly = false;

  searchParkingLocations() {
    if (this.filteredParking && this.filteredParking.length > 0) {
      this.filteredParking = [];
    }

    // ถ้าไม่มีคำค้นหา และไม่ได้ติ๊ก EV charger -> เคลียร์ผลลัพธ์
    if (this.textSearch === '' && !this.isSearchEvChargerOnly) {
      this.filteredParking = [];
      // this.showWarning('กรุณากรอกคําค้นหา');
      return;
    }

    // ถ้าไม่มีคำค้นหา แต่ติ๊ก EV charger -> แสดงทั้งหมดที่เป็น EV
    // หรือถ้ามีคำค้นหา -> ค้นหาตามปกติ + filter EV ถ้าติ๊ก

    let baseData = this.markerPositions;

    // 1. Filter by Text
    if (this.textSearch !== '') {
      baseData = baseData.filter((parking) => {
        const search = parking.name;
        return search.toLowerCase().includes(this.textSearch.toLowerCase());
      });
    }

    // 2. Filter by EV Charger
    if (this.isSearchEvChargerOnly) {
      baseData = baseData.filter(parking => parking.evCharger === true);
    }

    this.filteredParking = baseData;

    if (this.filteredParking.length === 0) {
      // this.showWarning('ไม่พบสถานที่ที่ค้นหา');
      this.filteredParking = null;
    }

    console.log('Search result:', this.textSearch, "EV Only:", this.isSearchEvChargerOnly, ":", this.filteredParking);
  }
  selectSearchParking(markerLocation: any) {
    this.textSearch = markerLocation.name;

    // ✅ เซ็ทศูนย์กลางไปที่ marker
    this.map.googleMap!.setCenter({ lat: markerLocation.lat, lng: markerLocation.lng });
    this.map.googleMap!.setZoom(16);

    // เก็บสถานะ searchLocation ไว้
    this.searchLocation = { lat: markerLocation.lat, lng: markerLocation.lng };

    console.log('Selected marker:', markerLocation);

    this.isSearchOpen = false;
  }
  clearSearchParking() {
    this.centerMapOnButtonLocation();
    this.textSearch = '';
    this.isSearchOpen = false;
  }


  // ------------------ ระยะทาง ------------------
  onRadiusChange() {
    console.log('ระยะใหม่ (เมตร):', this.selectedRadius, (this.selectedRadius * 1000));

    // this.filterNearbyParking_custom(this.currentLocation, (this.selectedRadius * 1000));
    this.runFunctionFilterActive();
    this.setMarkerMap();
  }

  // ---------------------- ตรวจสอบ ----------------------
  runFunctionFilterActive() {
    // เรียกข้อมูลเริ่มต้น
    this.resetData();

    // เช็ค filter ระยะทาง
    if (this.nearbyFormLocation === 1 && !this.isCustomRadius) {
      //....
    }
    else if (this.nearbyFormLocation === 2 && !this.isCustomRadius) {
      if (this.currentLocation) {
        this.filterNearbyParking_ten_km(this.currentLocation, 10000);
      }
      else {
        this.showError(
          this.currentLanguage == 'TH'
            ? 'คุณยังไม่มีการตำแหน่งปัจจุบัน'
            : 'You do not have a current position yet'
        );
      }
    }
    else {
      this.centerMapOnCurrentLocation(15);
      this.updateCurrentLocationMarker();
    }

    // เช็ค filter ระยะทางแบบ Custom
    if (this.isCustomRadius) {
      this.filterNearbyParking_custom(this.currentLocation, (this.selectedRadius * 1000));
    }

    // เช็ค filter ประเภท
    if (this.filterForm == 1) {
      this.filterEvChargerMarkers(this.currentLocation, 10000);
      this.customMarkers = this.customMarkers.filter(marker => marker.evCharger === true);
    }

    // ซูมแผนที่
    if (this.isCustomRadius) {
      this.centerMapOnButtonLocation();
    }
    else {
      this.fitMapToaMarkers();
    }

    console.log("🔍 Check Filter ALL : ", this.customMarkers);
  }

  // ----------------------- Map -----------------------

  // -------- การสร้างเริ่มต้น ---------
  // สร้าง marker เริ่มต้น
  initMarkersAndCluster() {
    // สร้าง marker ตามข้อมูล
    this.markerPositions.forEach(pos => {
      // เรียกใช้ Class เพื่อสร้าง Icon marker 
      this.customMarkers.push(
        new CustomMarker(
          { lat: pos.lat, lng: pos.lng },
          this.map.googleMap!,
          pos.available,
          () => {
            const position = { lat: pos.lat, lng: pos.lng };
            const distance = this.calculateDistance(this.currentLocation, { lat: pos.lat, lng: pos.lng });
            const price = 100;
            this.openModal(pos.siteId, pos.name, position, pos.available, distance, price);
          },
          this.ngZone,
          ["กรุงเทพมหานคร", "สยาม", "พารากอน"],
          pos.evCharger
        )
      );
    });
    console.log("Create markers : ", this.markerPositions.length, this.customMarkers);
  }
  // เริ่มตรวจจับตําแหน่งปัจจุบัน
  startWatchingPosition() {
    if (navigator.geolocation) {
      this.watchId = navigator.geolocation.watchPosition(
        (position) => {
          this.currentLocation = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          if (this.isFirstUpdate) {
            if (this.targetLat === null || this.targetLng === null) {
              this.centerMapOnCurrentLocation(15);
            }
            this.isFirstUpdate = false;
          }

          this.updateCurrentLocationMarker();
        },
        (error) => {
          console.error('Geolocation watch error:', error);

          // 🔥 ตั้งค่าตำแหน่งเริ่มต้นถ้าไม่ได้รับ location
          if (this.isFirstUpdate) {
            this.currentLocation = this.defaultLocation;
            if (this.targetLat === null || this.targetLng === null) {
              this.centerMapOnCurrentLocation(8);
            }
            // this.fitMapToaMarkers(); // ทำให้ขยายพอดีกับ markers

            //this.updateCurrentLocationMarker();
            this.isFirstUpdate = false;
          }
        },
        {
          enableHighAccuracy: true,
          maximumAge: 10000,
          timeout: 10000,
        }
      );
    } else {
      console.error('Geolocation not supported');
      // 🔥 Fallback เมื่อ browser ไม่รองรับ
      if (this.isFirstUpdate) {
        this.currentLocation = this.defaultLocation;
        if (this.targetLat === null || this.targetLng === null) {
          this.centerMapOnCurrentLocation(8);
        }
        //this.fitMapToaMarkers(); // ทำให้ขยายพอดีกับ markers

        //this.updateCurrentLocationMarker();
        this.isFirstUpdate = false;
      }
    }
  }


  // ------------ Modal ---------
  openModal(site_id: number, name: string, position: google.maps.LatLngLiteral, available: number, distance: number, price: number) {
    this.selectSiteId = site_id;
    this.selectName = name;
    this.selectPosition = position;
    this.selectedAvailable = available;
    this.selectedDistance = distance;
    this.selectedPrice = price;
    this.selectPublicRef = this.markerPositions.find(p => p.siteId === site_id)?.publicRef ?? null;
    this.showModal = true;
  }

  // ------- Icon ตําแหน่งปัจจุบัน ----------
  updateCurrentLocationMarker() {
    if (this.map && this.currentLocation) {
      if (this.currentLocationMarker) {

        const oldPos = this.currentLocationMarker.getPosition();
        const newPos = this.currentLocation;

        // ✅ ตรวจสอบว่าตำแหน่งเปลี่ยนจริงหรือไม่
        if (oldPos && oldPos.lat() === newPos.lat && oldPos.lng() === newPos.lng) {
          console.log('ตำแหน่งเดิม ไม่ต้องอัปเดต');
          return;
        }

        // Move existing marker to new position
        this.currentLocationMarker.setPosition(this.currentLocation);
        this.currentLocationMarker.setMap(this.map.googleMap!);

      } else {
        const blueDotIcon: google.maps.Icon = {
          url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="60" height="60" >
              <circle cx="30" cy="30" r="10" fill="#4285F4"/>
              <circle cx="30" cy="30" r="10" fill="#4285F4">
                <animate attributeName="r" from="10" to="25" dur="1.5s" repeatCount="indefinite" begin="0s" fill="freeze" />
                <animate attributeName="opacity" from="0.5" to="0" dur="1.5s" repeatCount="indefinite" begin="0s" fill="freeze" />
              </circle>
            </svg>
          `),
          scaledSize: new google.maps.Size(40, 40),
        };

        // Create marker the current position
        this.currentLocationMarker = new google.maps.Marker({
          position: this.currentLocation,
          map: this.map.googleMap!,
          icon: blueDotIcon,
          zIndex: 0, // ให้อยู่บนสุด
        });

        this.markers.push(this.currentLocationMarker);
        this.initMarkersAndCluster();

        this.isLoading = false;
      }

      console.log('Current location marker updated', this.currentLocation);
    }
  }

  // -------- กรองแสดงจุดจอดรถ ----------
  filterNearbyParking_ten_km(center: google.maps.LatLngLiteral, radiusMeters: number) {
    // ล้าง marker บน map
    this.customMarkers.forEach(marker => marker.setMap(null));

    // จำลองข้อมูลจุดจอดรถ
    const customMarkerDemo: CustomMarker[] = [];
    this.searchLocation = center; // เก็บตำแหน่งที่ค้นหา

    // 🔥 Filter positions within radius
    const nearbyPositions = this.markerPositions.filter(pos =>
      this.getDistanceMeters(center, { lat: pos.lat, lng: pos.lng }) <= radiusMeters
    );
    console.log("nearbyPositions", nearbyPositions);

    // 🔥 Create new CustomMarker for each nearby position
    nearbyPositions.forEach(pos => {
      const available = pos.available;
      const distance = this.calculateDistance(this.currentLocation, { lat: pos.lat, lng: pos.lng });
      const price = 100;

      const marker = new CustomMarker(
        { lat: pos.lat, lng: pos.lng },
        this.map.googleMap!,
        available,
        () => this.openModal(pos.siteId, pos.name, { lat: pos.lat, lng: pos.lng }, available, distance, price),
        this.ngZone,
        pos.search,
        pos.evCharger
      );

      customMarkerDemo.push(marker);
    });


    this.customMarkers = customMarkerDemo;
    // ตรวจสอบข้อมูลจุดจอดรถว่าง
    if (customMarkerDemo.length > 0) {
      this.fitMapToaMarkers_ten_km();
      this.showSuccess('พบจุดจอดรถใกล้เคียงในระยะ 10 กิโลเมตร จำนวน ' + customMarkerDemo.length + ' แห่ง');
    }
    else {
      // this.nearbyFormLocation = 1;
      console.warn('No markers to fit 10 km');
      this.showWarning('ไม่พบจุดจอดรถใกล้เคียงในระยะ 10 กิโลเมตร');

    }

    // สำหรับเลื่อนหน้าจอไปตําแหน่งปัจจุบัน
    this.centerMapOnCurrentLocation(15);
    this.updateCurrentLocationMarker();
  }
  filterNearbyParking_custom(center: google.maps.LatLngLiteral, radiusMeters: number) {
    // ล้าง marker บน map
    this.customMarkers.forEach(marker => marker.setMap(null));


    // จำลองข้อมูลจุดจอดรถ
    const customMarkerDemo: CustomMarker[] = [];
    this.searchLocation = center; // เก็บตำแหน่งที่ค้นหา

    // 🔥 Filter positions within radius
    const nearbyPositions = this.markerPositions.filter(pos =>
      this.getDistanceMeters(center, { lat: pos.lat, lng: pos.lng }) <= radiusMeters
    );
    console.log("nearbyPositions", nearbyPositions);

    // 🔥 Create new CustomMarker for each nearby position
    nearbyPositions.forEach(pos => {
      const available = pos.available;
      const distance = this.calculateDistance(this.currentLocation, { lat: pos.lat, lng: pos.lng });
      const price = 100;

      const marker = new CustomMarker(
        { lat: pos.lat, lng: pos.lng },
        this.map.googleMap!,
        available,
        () => this.openModal(pos.siteId, pos.name, { lat: pos.lat, lng: pos.lng }, available, distance, price),
        this.ngZone,
        pos.search,
        pos.evCharger
      );

      customMarkerDemo.push(marker);
    });


    this.customMarkers = customMarkerDemo;
    // ตรวจสอบข้อมูลจุดจอดรถว่าง
    if (customMarkerDemo.length > 0) {
      // สร้าง marker บนแผนที่
      this.fitMapToaMarkers_custom();
      this.showSuccess('พบจุดจอดรถใกล้เคียงในระยะ' + this.selectedRadius + ' กิโลเมตร จำนวน ' + customMarkerDemo.length + ' แห่ง');
    }
    else {
      console.warn('No markers to fit custom radius');
      this.showWarning('ไม่พบจุดจอดรถใกล้เคียงในระยะที่กำหนด');
    }


    // สำหรับเลื่อนหน้าจอไปตําแหน่งปัจจุบัน
    //this.centerMapOnCurrentLocation(15);
    //this.updateCurrentLocationMarker();

  }
  //  แสดงข้อมูลตามจำแนกสี 
  filterParkingByColor(index: number) {
    let filteredMarkersData: any[] = [];

    switch (index) {
      case 0: // Red < 5
        filteredMarkersData = this.markerPositions.filter(pos => pos.available < 1);
        break;
      case 1: // Yellow 10-9
        filteredMarkersData = this.markerPositions.filter(pos => pos.available >= 1 && pos.available < 10);
        break;
      case 2: // Green >= 10
        filteredMarkersData = this.markerPositions.filter(pos => pos.available >= 10);
        break;
      case -1:
        filteredMarkersData = this.markerPositions;
        break;
    }

    // 🔥 clear markers เดิม
    this.clearCustomMarkers();

    // 🔥 สร้าง marker ใหม่โดยใช้ CustomMarker
    this.customMarkers = filteredMarkersData.map(pos => {
      return new CustomMarker(
        { lat: pos.lat, lng: pos.lng },
        this.map.googleMap!,
        pos.available,
        () => {
          const distance = this.calculateDistance(this.currentLocation, { lat: pos.lat, lng: pos.lng });
          const price = 100;
          this.openModal(pos.siteId, pos.name, { lat: pos.lat, lng: pos.lng }, pos.available, distance, price);
        },
        this.ngZone,
        pos.search,
        pos.evCharger
      );
    });
  }
  clearCustomMarkers() {
    if (this.customMarkers && this.customMarkers.length > 0) {
      this.customMarkers.forEach(marker => {
        if (marker.onRemove) {
          marker.onRemove();
        }
      });
      this.customMarkers = [];
    }
  }
  // กรองแสดง EV charger
  filterEvChargerMarkers(center: google.maps.LatLngLiteral, radiusMeters: number) {
    // ล้าง marker บน map
    this.customMarkers.forEach(marker => marker.setMap(null));

    // จำลองข้อมูลจุดจอดรถ
    const customMarkerDemo: CustomMarker[] = [];
    this.searchLocation = center; // เก็บตำแหน่งที่ค้นหา

    // 🔥 Filter positions within radius
    const nearbyPositions = this.markerPositions.filter(pos =>
      this.getDistanceMeters(center, { lat: pos.lat, lng: pos.lng }) <= radiusMeters
    );
    console.log("nearbyPositions", nearbyPositions);

    // 🔥 Create new CustomMarker for each nearby position
    nearbyPositions.forEach(pos => {
      const available = pos.available;
      const distance = this.calculateDistance(this.currentLocation, { lat: pos.lat, lng: pos.lng });
      const price = 100;

      const marker = new CustomMarker(
        { lat: pos.lat, lng: pos.lng },
        this.map.googleMap!,
        available,
        () => this.openModal(
          pos.siteId,
          pos.name,
          { lat: pos.lat, lng: pos.lng },
          available,
          distance,
          price,
        ),
        this.ngZone,
        pos.search,
        pos.evCharger
      );

      customMarkerDemo.push(marker);
    });


    this.customMarkers = customMarkerDemo;
    // ตรวจสอบข้อมูลจุดจอดรถว่าง
    if (customMarkerDemo.length > 0) {
      this.fitMapToaMarkers_custom();
    }
    else {
      console.warn('No markers to fit custom radius');
      this.showWarning('ไม่พบจุดจอดรถ Ev charger ใกล้เคียงในระยะที่กำหนด');
    }
  }


  // ----- สร้าง Marker บนแผนที่ -----
  setMarkerMap() {
    if (this.customMarkers.length == 0) {
      this.removeMarkers();
      return
    }
    this.customMarkers.forEach(marker => marker.setMap(this.map.googleMap!));
  }

  // ----- ลบ marker -----
  removeMarkers() {
    // Clear markers
    this.customMarkers.forEach(marker => marker.setMap(null));
    this.customMarkers = [];

    // Clear markers search
    if (this.searchLocationMarker) {
      this.searchLocationMarker.setMap(null);
      this.searchLocationMarker = undefined;
    }

    console.log('All markers removed');
  }

  // ----- รีเซ็ต -----
  resetData() {
    // Close infoWindow if open
    this.infoWindow.close();

    // Clear nearby markers
    // this.nearbyFormLocation = -1;

    // Clear filter
    this.activeIndex = -1;

    // Clear text input
    const input = document.getElementById('search-box') as HTMLInputElement;
    if (input) input.value = '';

    // Remove search location marker
    if (this.searchLocationMarker) {
      this.searchLocationMarker.setMap(null);
      this.searchLocationMarker = undefined;
    }


    // 🔴 Clear custom markers
    this.customMarkers.forEach(marker => marker.setMap(null));
    this.customMarkers = [];


    // 🔥 Recreate all markers with CustomMarker
    this.markerPositions.forEach(pos => {
      const available = pos.available;
      const distance = this.calculateDistance(this.currentLocation, { lat: pos.lat, lng: pos.lng });
      const price = 100;

      const marker = new CustomMarker(
        { lat: pos.lat, lng: pos.lng },
        this.map.googleMap!,
        available,
        () => this.openModal(pos.siteId, pos.name, { lat: pos.lat, lng: pos.lng }, available, distance, price),
        this.ngZone,
        pos.search,
        pos.evCharger
      );

      this.customMarkers.push(marker);
    });

    this.searchLocation = undefined;

    console.log('Markers reset to show all parking');
  }



  // ---------- ค้นหา ---------
  addSearchLocationMarker(location: google.maps.LatLngLiteral) {
    // Remove previous search marker if exists
    if (this.searchLocationMarker) {
      this.searchLocationMarker.setMap(null);
    }

    this.searchLocationMarker = new google.maps.Marker({
      position: location,
      map: this.map.googleMap!,
      icon: {
        url: './icons/search-location.png', // หรือใช้ data URL SVG
        scaledSize: new google.maps.Size(30, 30),
      },
    });
  }

  // --------- สูตรคำนวณ -------
  //คํานวณระยะทาง
  calculateDistance(p1: google.maps.LatLngLiteral, p2: google.maps.LatLngLiteral): number {
    const R = 6371; // km
    const dLat = (p2.lat - p1.lat) * Math.PI / 180;
    const dLng = (p2.lng - p1.lng) * Math.PI / 180;
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(p1.lat * Math.PI / 180) * Math.cos(p2.lat * Math.PI / 180) *
      Math.sin(dLng / 2) * Math.sin(dLng / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c; // ระยะทางหน่วย km
  }

  // ระยะทางระหว่างจุด
  getDistanceMeters(p1: google.maps.LatLngLiteral, p2: google.maps.LatLngLiteral): number {
    const R = 6371e3; // meters
    const φ1 = p1.lat * Math.PI / 180;
    const φ2 = p2.lat * Math.PI / 180;
    const Δφ = (p2.lat - p1.lat) * Math.PI / 180;
    const Δλ = (p2.lng - p1.lng) * Math.PI / 180;

    const a = Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
      Math.cos(φ1) * Math.cos(φ2) *
      Math.sin(Δλ / 2) * Math.sin(Δλ / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

    const d = R * c;
    return d;
  }




  // -------- แสดงตำแหน่งปัจจุบัน --------
  centerMapOnCurrentLocation(zoomSet: number) {
    if (this.currentLocation) {
      this.center = this.currentLocation;
      this.zoom = zoomSet;
      if (this.map && this.map.googleMap) {
        this.map.googleMap.setCenter(this.currentLocation);
      }
    }
  }
  // ปุ่มแสดงตำแหน่งปัจจุบัน
  centerMapOnButtonLocation() {
    if (this.currentLocation) {
      this.center = this.currentLocation;
      this.zoom = 15;
      if (this.map && this.map.googleMap) {
        this.map.googleMap.setCenter(this.currentLocation);
      }
      this.updateCurrentLocationMarker(); // 🔥 เพิ่มบรรทัดนี้
    }
  }




  // ----------- การซูมแผนที่ --------------
  // ทั้งหมด
  fitMapToaMarkers() {
    if (!this.map || !this.map.googleMap) {
      console.warn('Map not ready');
      return;
    }

    const bounds = new google.maps.LatLngBounds();

    // ✅ ใช้ customMarkers ของคุณ
    if (this.customMarkers.length === 0) {
      // console.warn('No markers to fit');
      // this.showWarning('ไม่พบจุดจอดรถ');

      return;
    }

    this.customMarkers.forEach(marker => {
      bounds.extend(new google.maps.LatLng(marker['position']));
    });

    // ✅ Fit map to these bounds
    if (bounds) {
      this.map.googleMap.fitBounds(bounds);
    }

    console.log('Fit map to markers', this.customMarkers);
  }
  // 10 km
  fitMapToaMarkers_ten_km() {
    if (!this.map || !this.map.googleMap) {
      console.warn('Map not ready');
      return;
    }

    const bounds = new google.maps.LatLngBounds();

    // ✅ ใช้ customMarkers ของคุณ
    if (this.customMarkers.length === 0) {
      console.warn('No markers to fit 10 km');
      this.showWarning('ไม่พบจุดจอดรถใกล้เคียงในระยะ 10 กิโลเมตร');

      return;
    }

    this.customMarkers.forEach(marker => {
      bounds.extend(new google.maps.LatLng(marker['position']));
    });

    // ✅ Fit map to these bounds
    this.map.googleMap.fitBounds(bounds);

    console.log('Fit map to markers', this.customMarkers);
  }
  fitMapToaMarkers_custom() {
    if (!this.map || !this.map.googleMap) {
      console.warn('Map not ready');
      return;
    }

    const bounds = new google.maps.LatLngBounds();

    // ✅ ใช้ customMarkers ของคุณ
    if (this.customMarkers.length === 0) {
      console.warn('No markers to fit custom radius');
      this.showWarning('ไม่พบจุดจอดรถใกล้เคียงในระยะที่กำหนด');

      return;
    }

    this.customMarkers.forEach(marker => {
      bounds.extend(new google.maps.LatLng(marker['position']));
    });

    // ✅ Fit map to these bounds
    this.map.googleMap.fitBounds(bounds);

    console.log('Fit map to markers', this.customMarkers);
  }




  /*############################################# API #################################################*/
  getParkingLocations() {
    this.apiParkingCenterService.ParkingLocation(this.token).subscribe({
      next: (response) => {
        if (response) {
          console.log("Parking Location response : ", response);
          this.markerPositions = response.map(x => ({ ...x, search: ['กรุงเทพมหานคร', 'พารากอน', 'สยาม'], distance: 10 }));
          this.checkAndCenterOnPassedCoordinates();
        }
        else {
          console.log("Parking Location response Not Found!");
        }
      }, error: (err) => {
        console.error('โหลดข้อมูลล้มเหลว', err);
      }
    });
  }
  // Topup
  getHomeTopUp() {
    this.isLoading = true;
    if (this.uid) {
      this.apiTopUpService.getHomeTopUp(this.uid, this.token).subscribe({
        next: (response: HomeTopUpModel) => {
          console.log('response data Home Top Up : ', response);
          this.isLoading = false;
          this.topUpData = response;

          sessionStorage.setItem('homeTopUp', JSON.stringify(response));
        },
        error: (err) => {
          console.error('โหลดข้อมูล Home Top Up ล้มเหลว', err);
          this.isLoading = false;
        },
      });
    } else {
      this.showWarning(
        this.currentLanguage === 'TH'
          ? 'ไม่พบ LINE uid กรุณาเข้าใหม่ผ่าน /register'
          : 'Missing LINE uid. Please re-enter via /register.'
      );
      return;
    }
  }

}

/* ------------------------------------------------------- Custom Marker ------------------------------------------------------- */

class CustomMarker extends google.maps.OverlayView {
  private div!: HTMLDivElement;

  constructor(
    private position: google.maps.LatLngLiteral,
    private map: google.maps.Map,
    private available: number,
    private onClick: () => void,
    private ngZone: NgZone,
    private search: string[],
    public evCharger: boolean
  ) {
    super();
    this.map = map;
    this.setMap(map);

  }

  // เพิ่ม ICON PARKING
  override onAdd() {
    // 1. สร้าง HTML Element หลัก
    this.div = document.createElement('div');
    this.div.className = 'marker-wrapper';

    // 2. ตั้งค่า Style พื้นฐานของ Overlay
    this.div.style.position = 'absolute';
    this.div.style.cursor = 'pointer';
    this.div.style.zIndex = '50'; // ให้ลอยอยู่เหนือแผนที่พื้นฐาน

    // 3. Logic เลือกสีตามจำนวน (Available)
    let bgColor = '';
    let textColor = 'white';
    let ringColor = '';

    if (this.available < 1) {
      // เต็ม: สีแดง
      bgColor = '#EF4444';
      ringColor = 'rgba(239, 68, 68, 0.3)';
    } else if (this.available >= 1 && this.available < 10) {
      // ว่างน้อย: สีเหลือง (ตัวหนังสือดำเพื่อให้อ่านง่ายขึ้น)
      bgColor = '#F59E0B';
      textColor = 'white';
      ringColor = 'rgba(245, 158, 11, 0.3)';
    } else {
      // ว่างมาก: สีเขียว
      bgColor = '#10B981';
      ringColor = 'rgba(16, 185, 129, 0.3)';
    }

    // 4. สร้าง UI ภายใน (Marker ทรงแคปซูล + หางลูกศร)
    this.div.innerHTML = `
      <div style="
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        /* ดึงแกน X กลับมา 50% และดึงแกน Y ขึ้นไป 100% เพื่อให้ปลายแหลม (หาง) จิ้มถูกจุด */
        transform: translate(-50%, -100%); 
        transition: transform 0.2s cubic-bezier(0.25, 0.8, 0.25, 1); /* Animation นุ่มนวล */
      "
      /* เพิ่ม Z-Index ตอน Hover เพื่อให้ Marker นี้เด้งมาบังอันอื่นถ้ามันซ้อนกัน */
      onmouseover="this.style.transform='translate(-50%, -115%) scale(1.1)'; this.parentElement.style.zIndex = '100';"
      onmouseout="this.style.transform='translate(-50%, -100%) scale(1)'; this.parentElement.style.zIndex = '50';"
      >
        <div style="
          background-color: ${bgColor};
          color: ${textColor};
          padding: 6px 10px;
          border-radius: 9999px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.3), 0 0 0 4px ${ringColor};
          display: flex;
          align-items: center;
          gap: 6px;
          white-space: nowrap; /* ห้ามขึ้นบรรทัดใหม่ สำคัญมากสำหรับเลขหลักพัน */
          font-family: 'Sarabun', sans-serif; /* แนะนำให้ใส่ font ไทยถ้ามี */
          min-width: 45px;
          justify-content: center;
        ">
          <div style="
            background: rgba(255,255,255,0.25);
            border-radius: 50%;
            width: 20px;
            height: 20px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            font-weight: 800;
          ">P</div>

          <span style="
            font-weight: 700;
            font-size: 15px;
            line-height: 1;
            margin-top: 1px; /* จัดกึ่งกลางทางสายตาเล็กน้อย */
          ">${this.available.toLocaleString()}</span>
        </div>

        <div style="
          width: 0; 
          height: 0; 
          border-left: 6px solid transparent;
          border-right: 6px solid transparent;
          border-top: 8px solid ${bgColor}; /* สีเดียวกับพื้นหลัง */
          transform: translateY(-1px); /* ลบรอยต่อระหว่างหัวกับหาง */
          filter: drop-shadow(0 2px 1px rgba(0,0,0,0.1));
        "></div>
      </div>
    `;

    // 5. จัดการ Event Click
    this.div.addEventListener('click', (e) => {
      e.stopPropagation(); // สำคัญ: ป้องกันไม่ให้ทะลุไปกดโดนแผนที่ข้างหลัง
      this.ngZone.run(() => {
        this.onClick();
      });
    });

    // 6. เพิ่ม Element เข้าไปใน Map Pane
    const panes = this.getPanes();
    if (panes) {
      panes.overlayMouseTarget.appendChild(this.div);
    }
  }


  override draw() {
    const projection = this.getProjection();
    const pos = projection.fromLatLngToDivPixel(new google.maps.LatLng(this.position));
    if (pos && this.div) {
      this.div.style.left = pos.x - 25 + 'px'; // adjust for icon center
      this.div.style.top = pos.y - 50 + 'px';  // adjust for icon bottom
    }
  }

  override onRemove() {
    if (this.div && this.div.parentNode) {
      //this.div.parentNode.removeChild(this.div); // ✅ ลบ DOM
      this.div.remove(); // ✅ ลบ DOM
      console.log('🧹 Marker DOM removed');
    }
  }
}

